import React from 'react'
import {Field} from "../ui/elements/field";
import {EnvelopeIcon} from "@heroicons/react/24/solid";
import {Button} from "../ui/elements/button";
import {Form} from "../ui/elements/form";
import * as API from '../../api'
import {useNavigate} from "react-router";
import {useAuth} from "../../contexts/auth_context";

const OTPLength = 6

const OTPForm = props => {
  const {email} = props
  const navigate = useNavigate()
  const [otpCode, setOTPCode] = React.useState()
  const {setUser} = useAuth()

  const onChange = evt => {
    const {value} = evt.target
    if (value.length !== OTPLength) return

    API.My.Session.create(email, value).then((u) => {
      setUser(u)
      navigate("/", {state: {toast: {message: "Signed in"}}})
    })
  }

  return <div className="flex flex-col gap-4 items-center justify-center">
    <div className="text-center">
      Check your email for a login code
      <br/>
      and it enter it below.
    </div>
    <div className="flex items-center justify-center gap-4 w-full">
      <Field type="text" name="otp" className="otp-field text-center text-2xl w-full padding"
             pattern={`\\d{${OTPLength}}`}
             onChange={onChange} maxLength={OTPLength} autoComplete="one-time-code"/>
    </div>
  </div>
}

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export const SignInScreen = (props) => {
  const navigate = useNavigate();
  const [requested, setRequested] = React.useState(false);
  const { setUser } = useAuth()
  const [email, setEmail] = React.useState()


  const onSubmit = async evt => {
    const formData = new FormData(evt.target)
    const e = formData.get('email')

    API.My.Session.sendOTP(e).then(() => setEmail(e))

    // API.My.Session.credentials(formData.get('email')).then((creds) => {
    // if (creds) {
    //   const publicKey = {
    //     challenge: Uint8Array.from(Array.from(creds.challenge).map(letter => letter.charCodeAt(0))),
    //     rpId: window.location.hostname,
    //     allowCredentials: creds.credentials.map(cred => {
    //       const rawId = atob(cred.rawId_base64);
    //       return {
    //         id: Uint8Array.from(Array.from(rawId).map(letter => letter.charCodeAt(0))),
    //         transports: ['internal'],
    //         type: "public-key"
    //       }
    //     }),
    //     userVerification: "required",
    //   };
    //
    //   navigator.credentials.get({publicKey}).then(c => {
    //     result = {
    //       id: c.id,
    //       rawId: arrayBufferToBase64(c.rawId),
    //       response: {
    //         clientDataJSON: arrayBufferToBase64(c.response.clientDataJSON),
    //         attestationObject: arrayBufferToBase64(c.response.attestationObject),
    //         authenticatorData: arrayBufferToBase64(c.response.authenticatorData),
    //         signature: arrayBufferToBase64(c.response.signature)
    //       },
    //       authenticatorAttachment: "platform",
    //       clientExtensionResults: c.getClientExtensionResults(),
    //       type: "public-key",
    //     };
    //
    //     API.My.Session.receiveWebAuthnCredential(result).then((u) => {
    //       if (u) {
    //         setUser(u)
    //         navigate("/", {state: {toast: {message: "Signed in"}}})
    //       } else {
    //         sendLoginLink(formData.get('email')).then(() => setRequested(true))
    //       }
    //     })
    //   }).catch((e) => {
    //     sendLoginLink(formData.get('email')).then(() => setRequested(true))
    //   })
    // }
    // else {
    //   sendLoginLink(formData.get('email')).then(() => setRequested(true))
    // }
    //
    //
    // })
  }

  return email ? <OTPForm email={email}/> :
    <Form className="flex flex-col gap-8 w-full" onSubmit={onSubmit}>
      <h2 className="text-4xl font-[Axiforma_Black]">Sign In</h2>
      <div className="flex flex-col gap-4">
        <Field name="email" type="text" icon={EnvelopeIcon} autoCapitalize="off" spellCheck={false}
               placeholder="Email"/>
      </div>

      <div>
        <Button type="submit">Sign In</Button>
      </div>
    </Form>
}